import React from 'react';
import { FaPython, FaJava, FaJs, FaPhp, FaCuttlefish,FaRobot } from 'react-icons/fa'; // Language Icons
import { BiDotsHorizontalRounded } from 'react-icons/bi'; // Three dots icon

// Map languages to icons
const languageIcons = {
  Python: <FaPython size={25} color="#3776AB" />,
  JavaScript: <FaJs size={25} color="#F7DF1E" />,
  Java: <FaJava size={25} color="#007396" />,
  PHP: <FaPhp size={25} color="#4F5B93" />,
  'C++':<FaCuttlefish size={25} color="#00599C" />,
  Prompt:<FaRobot size={25} color="#00599C" />
};

const TaskCard = ({ task, onSolve }) => {
  return (
    <div className="task-card" onClick={() => onSolve(task)} style={{ cursor: 'pointer' }}>
      <div className="task-header">
        <div className="language">
        {languageIcons[task.language] || <FaRobot size={25} color="#00599C" />}
          <span>{task.language}</span>
        </div>

        <div className="difficulty">
          <span>{task.difficulty}</span> {/* Only display text for difficulty */}
        </div>
      </div>

      <h3>{task.title}</h3>
      <p className="description">{task.description}</p>
      <h4>Test Cases:</h4>
      <ul className="test-cases">
        {task.testCases.map((testCase, index) => (
          <li key={index}>{testCase}</li>
        ))}
      </ul>
      <p className="remarks">{task.remarks}</p>

      {/* Container for positioning the three dots */}
      <div className="task-footer" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-15px' }}>
        <BiDotsHorizontalRounded size={24} style={{ cursor: 'pointer' }} />
      </div>
    </div>
  );
};

export default TaskCard;
